import z from 'zod';

export const invitePatientSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  surname: z.string().min(1, 'Surname is required'),
  email: z.string().email('Invalid email address'),
});

export type InvitePatientFormValues = z.infer<typeof invitePatientSchema>;
